import React, { useState } from 'react';
import './Filter.css'
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next'


function RateFilter() {

    const categories = [
        { id: '1', label: '1' },
        { id: '2', label: '2' },
        { id: '3', label: '3' },
        { id: '4', label: '4' },
        { id: '5', label: '5' },
      ];
      const [activeCategory, setActiveCategory] = useState('1');

      const handleCategoryClick = (category) => {
        setActiveCategory(category);
      };
    
  return (
   <div className="w-100">
    <div className='category-buttons-div'>
      {categories.map((category) => (
        <button
          key={category.id}
          className={`category-button ${activeCategory === category.id ? 'actives' : 'not-active'}`}
          onClick={() => handleCategoryClick(category.id)}
        >
          {category.label}
        </button>
      ))}</div>
    </div>
  )
}

export default RateFilter



export function Sizefilter() {
    const allCategories = [
       
        'x','x2','x3','x4',             
 '31x','x1l','x.x','xs','xmoo','lq',
 '32x','x2l','xlx','xsa','xm;','la',
 '33x','xl3','xyx','xssa','xmo','sl',
 '34x','xl4','xux','xaas','xmyj','dl',
 '35x','xl2','xix','xzs','xmy','lv',
 '36x','xl','xxk','xxs','xmt','lb',
 '37x','xl33','xvx','cxs','xxxxxxxxxxxem','nl',
 '38x','xl9','xxd','xvs','xmw','lj',
 '39x','xlg','xdx','xsn','xmq','l',
        '555','x6','x5','x44',
      
    ];

    const itemsPerPage = 10;
    const [activeCategories, setActiveCategories] = useState([]);
    const [visibleCategories, setVisibleCategories] = useState(allCategories.slice(0, itemsPerPage));
    const [currentPage, setCurrentPage] = useState(1);

    const handleCategoryClick = (category) => {
        if (activeCategories.includes(category)) {
            setActiveCategories(activeCategories.filter((item) => item !== category));
        } else {
            setActiveCategories([...activeCategories, category]);
        }
    };

    const loadMoreCategories = () => {
        const nextPage = currentPage + 1;
        const endIndex = nextPage * itemsPerPage;
        setVisibleCategories(allCategories.slice(0, endIndex));
        setCurrentPage(nextPage);
    };
    return (
        <div className=" w-100 ">
            
            <div className='category-buttons-div'>
                {visibleCategories.map((category) => (
                    <button
                        key={category}
                        className={`category-button ${activeCategories.includes(category) ? 'active' : 'not-active'}`}
                        onClick={() => handleCategoryClick(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>
            <div className="load-more-button my-2">
                {visibleCategories.length < allCategories.length && (
                    <button  onClick={loadMoreCategories}>Load More</button>
                )}

                
            </div>
        
        </div>
    );
}


export function PriceFilter() {
  const {t} = useTranslation()

    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(5000000);
    
  return (
    <div>
        <form  className='  priceForm  '>
<div className='price-inputs-div '>
      <input placeholder=' 9 '  type="text" className=' bg-white priceinput ' id="minPrice" value={minPrice} onChange={(event) => setMinPrice(event.target.value)} required />
      <span className='price-inputs-to'> {t('to')}</span>

      <input placeholder=' 345 'type="text" className=' bg-white priceinput ' id="maxPrice" value={maxPrice} onChange={(event) => setMaxPrice(event.target.value)} required />
      </div>
     {(minPrice && maxPrice )? (
    <button className=" pricebtn" type="submit">
      {t('go')}
    </button>
  ) : null}
</form>






    </div>
  )
}

export  function Brands() {
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      if (checked) {
        setSelectedCheckboxes([...selectedCheckboxes, value]);
      } else {
        setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== value));
      }
    };
  
    const checkboxes = [
      { label:1 , value: "زارا" },
      { label:2 , value: "ال سي " },
      { label:3 , value: "كلب الدو" },
      { label:4 , value: "ديفاكتو" },
      { label:5 , value: "اديداس" },
      { label: 6, value: "ديجافو" },
      { label:7 , value: "اتش اند ام" },
      { label: 8, value: "باكو" },
      { label:9 , value: "بول اند بير" },
      { label:10 , value: "اماندا " },
      { label:11 , value: "ميبيلين" },
      { label:12 , value: "كيكو" },
    ];
  
    return (
      <div className=' w-100'>
       
        <div className='tair_l_div '>
          {checkboxes.map((checkbox) => (
        
            <div className=' my-1   d-flex justify-content-between flex-wrap' key={checkbox.value}>
              <label className='w-100   d-flex justify-content-between flex-wrap' key={checkbox.value}>
                <div className=' d-flex'>
                  <div className=' d-flex justify-content-left ' style={{ alignItems: 'center' }}>
                    <input 
                       style={{ display: 'none' }}
                      type="checkbox"
                      id={checkbox.value}
                      value={checkbox.value}
                      checked={selectedCheckboxes.includes(checkbox.value)}
                      onChange={handleCheckboxChange}
                     
                    />
                    <label className=" "htmlFor={checkbox.value} style={{ cursor: 'pointer', marginRight: '10px' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 28 28" fill="none">
                        <rect x="1" y="1" width="26" height="26" rx="7" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                        {selectedCheckboxes.includes(checkbox.value) && (
                          <path
                            d="M4 12L11 19L24 6"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        )}
                      </svg>
                    </label>
                  </div>
                  <div className=' d-flex mx-2 ' style={{alignItems:"center"}}>
                    <p className='a_l_par' style={{margin:"0px"}}>{checkbox.value}</p>
                   
                  </div>
                </div>
                
                <p>num</p>
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }
 
  export  function Colors() {
    const [selectedCheckcol, setSelectedCheckcol] = useState([]);

    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      if (checked) {
        setSelectedCheckcol([...selectedCheckcol, value]);
      } else {
        setSelectedCheckcol(selectedCheckcol.filter((item) => item !== value));
      }
    };
  
    const checkcol = [
      { hexacode:"col1", value: "#61AD92" },
      { hexacode:"col2", value: "000" },
      { hexacode:"col3", value: "fff" },
      { hexacode:"col4", value: "692b2b" },
      { hexacode:"col5", value: "61AD92" },
      { hexacode:"col6", value: "#1d4f40" },
      { hexacode:"col7", value: "592240" },
      { hexacode:"col8", value: "#1d2d4f" },
      { hexacode:"col9", value: "#425922" },
      { hexacode:"col10" , value:"#b9df0d" },
      { hexacode:"col11" , value:"df960d" },
      { hexacode:"col12" , value:"0ddfbc" },
    ];
   
    
   
    
    return (
      <div className=' w-100'>
       
        <div className='tair_l_div '>
          {checkcol.map((checkbox) => (
            // <div className=' my-1 bg-dark   d-flex justify-content-between flex-wrap' key={checkbox.value}>
              <label className='w-100 my-1   d-flex justify-content-between flex-wrap' key={checkbox.value}>
                <div className=' d-flex'>
                  <div className=' d-flex justify-content-left ' style={{ alignItems: 'center' }}>
                    <input 
                       style={{ display: 'none' }}
                      type="checkbox"
                      id={checkbox.value}
                      value={checkbox.value}
                      checked={selectedCheckcol.includes(checkbox.value)}
                      onChange={handleCheckboxChange}
                     
                    />
                    <label className=" "htmlFor={checkbox.value} style={{ cursor: 'pointer', marginRight: '10px' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 28 28" fill="none">
                        <rect x="1" y="1" width="26" height="26" rx="7" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                        {selectedCheckcol.includes(checkbox.value) && (
                          <path
                            d="M4 12L11 19L24 6"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        )}
                      </svg>
                    </label>
                  </div>
                  <div className=' d-flex mx-2 ' style={{alignItems:"center"}}>
                    <i style={{ background : `#${checkbox.value.replace("#", "")}`,color: `#${checkbox.value.replace("#", "")}`,width:"1rem",height:"1rem",borderRadius:"1rem" ,border:"0.1px gray solid"}}></i>
                    <p className='a_l_par mx-1' style={{margin:"0px"}}>{checkbox.hexacode}</p>
                   
                  </div>
                </div>
                
                <p>num</p>
              </label>
           
          ))}
      
        </div>
      </div>
    );
  }

export function Newest() {
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);

  const handleCheckboxChange = (value) => {
    setSelectedCheckbox(value);
  };

  const checkboxes = [
    { label: 1, value: "اخر 7 يوم" },
    { label: 2, value: "اخر 30 يوم" },
    { label: 3, value: "اخر 60 يوم" },
    { label: 4, value: "اخر 120 يوم" },
  ];

  return (
    <div className=" w-100">
    
      <div className="tair_l_div">
        {checkboxes.map((checkbox) => (
          <label
            className="w-100 d-flex justify-content-between flex-wrap"
            key={checkbox.value}
          >
            <div className="d-flex">
              <div
                className="d-flex justify-content-left"
                style={{ alignItems: "center" }}
              >
                <input
                  style={{ display: "none",border: "2px solid black" }}
                  type="radio"
                  id={checkbox.value}
                  value={checkbox.value}
                  checked={selectedCheckbox === checkbox.value}
                  onChange={() => handleCheckboxChange(checkbox.value)}
                />
                <label
                  className=""
                  htmlFor={checkbox.value}
                  style={{ cursor: "pointer", marginRight: "10px" }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 28 28" fill="none">
                    <circle cx="14" cy="14" r="13" stroke="#D99D2B" strokeWidth="2" fill={selectedCheckbox === checkbox.value ? "#D99D2B" : "none"} strokeLinejoin="round" />
                    {selectedCheckbox === checkbox.value && (
                      <circle cx="14" cy="14" r="5" fill="white" />
                    )}
                  </svg>
                </label>
              </div>
              <div className="d-flex mx-2" style={{ alignItems: "center" }}>
                <p className="a_l_par" style={{ margin: "0px" }}>
                  {checkbox.value}
                </p>
              </div>
            </div>
            <p>num</p>
          </label>
        ))}
      </div>
    </div>
  );
}

export function Sale() {
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);

  const handleCheckboxChange = (value) => {
    setSelectedCheckbox(value);
  };

  const checkboxes = [
    { label: 1, value: "20%"},
    { label: 2, value: "30%"},
    { label: 3, value: "50%"},
    { label: 4, value: "70%"},
  ];

  return (
    <div className=" w-100">
     
      <div className="tair_l_div">
        {checkboxes.map((checkbox) => (
          <label
            className="w-100 d-flex justify-content-between flex-wrap"
            key={checkbox.value}
          >
            <div className="d-flex">
              <div
                className="d-flex justify-content-left"
                style={{ alignItems: "center" }}
              >
                <input
                  style={{ display: "none",border: "2px solid black"}}
                  type="radio"
                  id={checkbox.value}
                  value={checkbox.value}
                  checked={selectedCheckbox === checkbox.value}
                  onChange={() => handleCheckboxChange(checkbox.value)}
                />
                <label
                  className=""
                  htmlFor={checkbox.value}
                  style={{ cursor: "pointer", marginRight: "10px" }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 28 28" fill="none">
                    <circle cx="14" cy="14" r="13" stroke="#D99D2B" strokeWidth="2" fill={selectedCheckbox === checkbox.value ? "#D99D2B" : "none"} strokeLinejoin="round" />
                    {selectedCheckbox === checkbox.value && (
                      <circle cx="14" cy="14" r="5" fill="white" />
                    )}
                  </svg>
                </label>
              </div>
              <div className="d-flex mx-2" style={{ alignItems: "center" }}>
                <p className="a_l_par" style={{ margin: "0px" }}>
                  {checkbox.value}
                </p>
              </div>
            </div>
            <p>num</p>
          </label>
        ))}
      </div>
    </div>
  );
}





export function SearchFilterSide ({id}) {

  const [ShowSale, setShowSale] = useState(false);
  const [ShowNewest, setShowNewest] = useState(false);
  const [ShowColors, setShowColors] = useState(false);
  const [ShowBrands, setShowBrands] = useState(false);
  const [ShowPriceFilter, setShowPriceFilter] = useState(false);
  const [ShowSizefilter, setShowSizefilter] = useState(false);
  const [ShowRateFilter, setShowRateFilter] = useState(false)

  const handleSaleClick = () => {
    setShowSale(!ShowSale);   
  };

  const handleNewestClick = () => {
    setShowNewest(!ShowNewest);
  };
  const handleColorsClick = () => {
    setShowColors(!ShowColors);
  };
  const handleBrandsClick = () => {
    setShowBrands(!ShowBrands);
  }; 
   const handlePriceFilterClick = () => {
    setShowPriceFilter(!ShowPriceFilter);
  };  
  const handleSizefilterClick = () => {
    setShowSizefilter(!ShowSizefilter);
  }; 
   const handleRateFilterClick = () => {
    setShowRateFilter (!ShowRateFilter);
  };
  const {t} = useTranslation()
  return (

    
    <div className='filterside-div'>
      <div className='filter_type_h'>
      {t('filterwith')}    </div>

<div className='filters-div'>

  <div  className="d-flex justify-content-between  w-100"  role="button"  onClick={handlePriceFilterClick} >
<span className="filter_type">{t('price')}</span>
{!ShowPriceFilter ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}
</div>

{ShowPriceFilter && (<PriceFilter></PriceFilter>)}



<div className='filterline'></div>



<div  className="d-flex justify-content-between w-100" role="button"  onClick={handleBrandsClick} >

<span className="filter_type" >{t('brand')}</span>
{!ShowBrands ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}

</div>
      {ShowBrands && (<Brands></Brands>)}
<div className='filterline'></div>

<div  className="d-flex justify-content-between  w-100"  role="button"  onClick={handleSaleClick} >

<span className="filter_type">{t('sale')}</span>
{!ShowSale ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}

</div>
      {ShowSale && (<Sale></Sale>)}
<div className='filterline'></div>

<div  className="d-flex justify-content-between  w-100 " role="button"  onClick={handleNewestClick}>

<span className="filter_type"  >{t('new')}</span>
{!ShowNewest ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}


</div>
      {ShowNewest && (<Newest></Newest>)}
<div className='filterline'></div>

<div  className="d-flex justify-content-between  w-100 " role="button"  onClick={handleColorsClick}>
<span className="filter_type"  >{t('color')}</span>
{!ShowColors ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}

</div>
      {ShowColors && (<Colors></Colors>)}
<div className='filterline'></div>
<div  className="d-flex justify-content-between  w-100" role="button"  onClick={handleSizefilterClick}> 

<span className="filter_type"  >{t('size')}</span>
{!ShowSizefilter ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}

</div>
      {ShowSizefilter && (<Sizefilter></Sizefilter>)}
<div className='filterline'></div>

<div  className="d-flex justify-content-between  w-100" role="button"  onClick={handleRateFilterClick}>

<span className="filter_type" >{t('rate')}</span>
{!ShowRateFilter ? <span className='filtersign'>+</span> : <span className='filtersign'>-</span>}

</div>
      {ShowRateFilter && (<RateFilter></RateFilter>)}
</div>   
    </div>
  )
}
